/**
 * Zentrale API-Konfiguration.
 *
 * Die Base-URL wird aus der Env-Variable REACT_APP_API_URL gelesen.
 * Fallback: http://localhost:8000 (lokal) bzw. window.location.origin (Server)
 */
const _raw = process.env.REACT_APP_API_URL;
// Wenn das Frontend nicht auf localhost geöffnet wurde (z. B. Zugriff vom Handy
// im LAN über 192.168.x.y:3000), darf die API-URL nicht hart auf "localhost"
// zeigen — sonst sucht der Browser im Handy seine eigene localhost. Wir
// ersetzen in dem Fall den Hostname-Teil durch den tatsächlichen Browser-Host.
const _rewriteForBrowser = (url) => {
  if (typeof window === "undefined" || !window.location) return url;
  const browserHost = window.location.hostname;
  if (browserHost === "localhost" || browserHost === "127.0.0.1") return url;
  try {
    const u = new URL(url);
    if (u.hostname === "localhost" || u.hostname === "127.0.0.1") {
      u.hostname = browserHost;
      return u.toString().replace(/\/$/, "");
    }
  } catch (_) {}
  return url;
};
const _hostFallback =
  (typeof window !== "undefined" && window.location)
    ? `${window.location.protocol}//${window.location.hostname}:8000`
    : "http://localhost:8000";
export const API_BASE = _rewriteForBrowser(
  (_raw != null && _raw !== "") ? _raw : _hostFallback
);
// Mi. 29 Apr. 2026 15:31:06 CEST
